import { PropsWithChildren, useEffect } from "react";
import { Else, If, Then, When } from "react-if";

import { UserStateData } from "../../user";

import { useAccess } from "../hooks/useAccess";

interface Props {
  onAccess?: () => void;
  placeholder?: () => JSX.Element;
  checkAccess: (data: UserStateData) => boolean;
}

export function Access(props: PropsWithChildren<Props>) {
  const { checkAccess, onAccess, placeholder, children } = props;

  const [loading, access] = useAccess({ checkAccess });

  useEffect(() => {
    if (access && onAccess) {
      onAccess();
    }
  }, [access, onAccess]);

  return (
    <If condition={loading}>
      <Then>{placeholder?.()}</Then>
      <Else>
        <When condition={access}>{children}</When>
      </Else>
    </If>
  );
}
